import { RouterProps, withRouter } from 'react-router';
import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import { IRouteMetadataType } from '../App/modules/Base/types/IRouteMetadataType';
import AssortementPromotionsInProductGroup from '../App/modules/Promotion/components/AssortementPromotionsInProductGroup/AssortementPromotionsInProductGroup';
import {
	maxDiscountInTitle,
	withTitlePostfix,
	withClickbait,
	pluralizerAssortementPromotions,
	currentEntryWord
} from '../App/utils/routeMetadataUtils';
import BaseRoute from './_BaseRoute';
import AdConfig from '../App/components/General/AdConfig/AdConfig';
import FlexWrapper from '../App/components/Layout/Flexbox/FlexWrapper';
import AdItem from '../App/components/General/AdItem/AdItem';


class AssortementPromotionsInProductGroupRoute extends BaseRoute {

	public static async getInitialProps(state: any) {
		const reduxData = await AssortementPromotionsInProductGroupRouteProps(state);

		return { reduxData };
	}

	public render() {
		const query = (this.props.match.params) ? this.props.match.params : {};

		return (
			<React.Fragment>

				<AdConfig
					desktopIds={[4403491]}
					mobileIds={[4403480, 4403479]}
					superbannerId={4403492}
					sitebarId={4403490}
				/>

				<Header />
				<MainNavigation />

				<FlexWrapper>
					<div>
						<AssortementPromotionsInProductGroup
							productGroupSlug={query.productGroup + ''}
							{...this.props}
						/>

						<Footer />
					</div>

					<AdItem
						desktopAdId={4403490}
						maxHeight={600}
						maxWidth={300}
						type="side"
						className="startBelowMenuBar"
					/>
				</FlexWrapper>

			</React.Fragment>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		AssortementPromotionsInProductGroupRoute,
		(props: any) => `appc-${props.match.params.productGroup}`,
		{
			pageTitle: (routeMetadata: IRouteMetadataType) =>
				`${routeMetadata.totalItemsCount || ''} ${currentEntryWord(routeMetadata.totalItemsCount, 'aktuelle', 'aktuelle')} ${routeMetadata.productGroup.title} ${pluralizerAssortementPromotions(routeMetadata.totalItemsCount)} ${maxDiscountInTitle(routeMetadata.maxItemDiscount)} - ${routeMetadata.productGroup.title} günstig kaufen`,
			metaTitle: (routeMetadata: IRouteMetadataType) =>
				withTitlePostfix(`${routeMetadata.productGroup.title} günstig kaufen » ${routeMetadata.totalItemsCount || ''} Sortimentsaktionen ${maxDiscountInTitle(routeMetadata.maxItemDiscount)}`),
			metaDescription: (routeMetadata: IRouteMetadataType) =>
				withClickbait(`Alle ${routeMetadata.productGroup.title} Sortimentsaktionen auf einen Blick » online informieren ✓ Preise vergleichen ✓ Rabatt sichern`, `✓ Jetzt fündig werden!`),
		} as IRouteMetadataSetterType,
	),
);
